<template>
  <img
    src="/images/utamed-logo-vertical-blanco.svg"
    alt="UTAMED"
    width="28"
    height="32"
    data-testid="admin-ui-svg-simple-logo"
  />
</template>
